<template>
  <Schema :text="getSchema" />
</template>

<script>
import { mapGetters } from 'vuex';
import Schema from './json-schema.vue';

export default {
    name: 'PropertySchema',
    props: {
      data: {
        type: Object,
        default: {},
      },
      enableRealEstateSchema: {
        type: Boolean,
        default: false,
      },
      enableSingleFamilySchema: {
        type: Boolean,
        default: false,
      }
    },
    components: { Schema },
    computed: {
        ...mapGetters('glb', ['glb']),
        getSchema() {
            const formattedAddress = this.data.geo.formatAddress || '';
            const url = this.data.dppUrl || '';
            const price = this.data.price || 0;
            const availability = this.data.isActive ? 'http://schema.org/InStock' : 'https://schema.org/SoldOut';
            const image = this.data.photoCount ? this.data.tnImgPath : this.glb.cdnUrl + 'images/nophoto_small.svg';
            const description = this.data.description || formattedAddress;

            let schemaList = [];

            if (this.enableRealEstateSchema) {
                schemaList.push({
                    "@context": "http://schema.org",
                    "@type": "RealEstateListing",
                    "name": formattedAddress,
                    "description": this.data.description,
                    "datePosted": new Date(this.data.listDate),
                });
            }

            if (this.enableSingleFamilySchema) {
                schemaList.push({
                  "@context": "http://schema.org",
                  "@type": "SingleFamilyResidence",
                  "name": formattedAddress,
                  url,
                  "address": {
                    "@type": "PostalAddress",
                    "streetAddress": this.data.geo.address || '',
                    "addressLocality": this.data.geo.city || '',
                    "postalCode": this.data.geo.zipcode || '',
                    "addressRegion": this.data.geo.state || '',
                  },
                });
            }

            schemaList.push({
                '@context': 'http://schema.org',
                '@type': 'Product',
                name: formattedAddress,
                offers: {
                    '@type': 'Offer',
                    priceCurrency: 'USD',
                    availability,
                    price,
                    url,
                },
                description,
                image,
            });

            return JSON.stringify(schemaList);
        },
    },
};
</script>